import { useState, useEffect } from 'react';

/**
 * Hook to determine the optimal logo format based on device capabilities
 * Returns app-icon.png which works well in both light and dark modes
 * The animated webp has a white background that doesn't work well in dark mode
 */
export const useOptimizedLogo = (preferStatic: boolean = false): string => {
  const [logoSrc, setLogoSrc] = useState('/app-icon.png');

  useEffect(() => {
    // Always use app-icon.png as it works well in both light and dark modes
    // The animated webp has a white background that doesn't work in dark mode
    setLogoSrc('/app-icon.png');
  }, [preferStatic]);

  return logoSrc;
};

/**
 * Hook to detect if the current device is iOS
 */
export const useIsIOS = (): boolean => {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || '';
    setIsIOS(/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream);
  }, []);

  return isIOS;
};